import React, { Component } from 'react';
import './style.scss'
import { connect } from 'react-redux'
import ItemImage from './components/ItemImage';
import ItemQuestion from './components/ItemQuestion';
import { Tabs, Tab } from 'react-bootstrap';
import QuestionsStudent from './components/QuestionsStudent';
import PropTypes from 'prop-types'
import AnswerStatistic from './components/AnswerStatistic';
import SliderBlockContent from '../../../SliderVIew/components/SliderBlockContent/SliderBlockContent';

const { TabPane } = Tabs;

class Slide extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  onChange = () => {

  }

  render() {
    const {formatMessage} = this.context;
    const {slide, item, items} =this.props;
    return (
      <div className="col-md-10">
      <div className="title-resentation">{item.name}</div>
        <div className="Slide">
          <div className="item">
            <div className="container-item" style={{background: 'green'}}>
              <SliderBlockContent items={items} activeItem={slide}/>
            </div>
          </div>
        </div>
  
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  slide: state.slider.slide,
  item: state.slider.item,
  items: state.slider.items,
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(Slide)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/components/Slide/index.jsx